import { render, staticRenderFns } from "./TextTemplateChooser.vue?vue&type=template&id=38818078&"
import script from "./TextTemplateChooser.vue?vue&type=script&lang=js&"
export * from "./TextTemplateChooser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports